import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/atul/WORK/MLH/react-components/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Switch from './Switch.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "switch"
    }}>{`Switch`}</h1>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<Switch\n  ui={{\n    radius: \'10\',\n    width: \'100\',\n    height: \'45\',\n    color: \'black\',\n    button: \'blue\',\n  }}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Switch,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      <Switch ui={{
        radius: "10",
        width: "100",
        height: "45",
        color: "black",
        button: "blue"
      }} mdxType="Switch" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      